import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";

class CreateWishlistItemSdkMethodPayload implements SdkMethodPayloadInterface {
    public readonly methodName: WISHLISTS_SDK_METHODS.CREATE_WISHLIST_ITEM;
    public readonly productId: number;
    public readonly variantId: number;
    public readonly wishlistId: number | null;
    public onSuccess: () => void;
    public onError: (error: Error) => void;

    constructor(
        productId: number,
        variantId: number,
        wishlistId: number | null,
        onSuccess: () => void,
        onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.CREATE_WISHLIST_ITEM;
        this.productId = productId;
        this.variantId = variantId;
        this.wishlistId = wishlistId;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default CreateWishlistItemSdkMethodPayload;
